import { Component, ElementRef, inject, input } from '@angular/core';

@Component({
  selector: 'ui-option',
  template: '<ng-content />',
})
export class OptionComponent<T = unknown> {
  readonly elementRef = inject(ElementRef);
  // Value to be stored when option is selected
  readonly value = input.required<T>();
  // Whether the option is disabled
  readonly disabled = input<boolean>(false);
}
